import Link from "next/link";
import { RedcandleIcon } from "../Utility/Icons/RedcandleIcon";

export function LogoButton() {
  return (
    <Link href="/#root" passHref>
      <a>
        <RedcandleIcon style={{ height: 38, width: 38 }}></RedcandleIcon>
      </a>
      {/* <img
        style={{
          height: 38,
          width: 38,
          paddingBottom: 2,
          color: "white",
        }}
        src="/imgs/icons/redcandle-logo.svg"
      ></img> */}
    </Link>
    // <LinkButton variant="contained" color="primary" to="/#root">
    //   <img style={{ height: 42 }} src="/imgs/_logo.png"></img>
    // </LinkButton>
  );
}
